// Back to where the person came from; the fallback when this tab has no
// history (opened directly, or from another site).
export const goBackOr = (history, fallback = '/') => {
  if (history.length > 1) history.goBack()
  else history.push(fallback)
}
